<template>
  <div class="container head-container">
<div class="d-flex justify-content-center align-items-center body-content">
      <div class="text-center content-wrapper">
        <img src="@/assets/images/check-circle.svg" alt="" class="check-icon" width="65" height="65" />
        <p class="font-24 heading-text fw-bold">
          企業登録が完了しました！
        </p>
        <p class="mb-8 description-text">
          気になる求人に「スカウト希望」すると<br />
          スカウトが届きやすくなります
        </p>
        <button
          class="btn btn-cstm btn-cstm-primary"
          @click="handleOkClick"
          :disabled="isLoadingProfile"
          data-testid="navigate-to-mypage-button"
        >
          <span class="btn-text-full">マイページへ（求人を見る）</span>
          <span class="btn-text-short">マイページへ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex';

export default {
  name: 'CompanyRegistrationComplete',
  data() {
    return {
      isLoadingProfile: true
    };
  },
  computed: {
    ...mapGetters({ profile: 'getProfile'})
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
    }),
    handleOkClick() {
      return this.$router.push('/job-listings');
    },
  },
  async created() {
    await this.setProfile();
    this.isLoadingProfile = false;
  }
};
</script>

<style scoped>
.content-wrapper {
  max-width: 750px;
  width: 100%;
  padding: 0 20px;
}

.check-icon {
  width: 39px;
  height: 39px;
  display: block;
  margin: 0 auto 30px;
}

.body-content {
  min-height: 75vh;
  padding-top: 20px;
}

.mb-8 {
  margin-bottom: 30px !important;
}

.btn-cstm {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  max-width: 402px;
  height: 57px;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  font-weight: 700 !important;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
  color: #fff !important;
  background-color: #006c6b !important;
  border-color: #006c6b !important;
}

.btn-cstm:hover {
  background-color: #005958 !important;
}

.btn-text-short {
  display: none;
}

.font-24 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700 !important;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
}

.heading-text {
  margin-bottom: 60px;
}

.description-text {
  font-family: 'Roboto', sans-serif;
  font-weight: 700 !important;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .body-content {
    padding-top: 40px;
  }

  .font-24 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
  }

  .description-text {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -1px;
  }

  .btn-cstm {
    width: 198px !important;
    max-width: 198px !important;
    height: 35px !important;
    padding: 10px;
    font-size: 16px;
  }

  .btn-text-full {
    display: none;
  }

  .btn-text-short {
    display: inline;
  }

  .check-icon {
    width: 35px;
    height: 35px;
  }

  .heading-text {
    margin-bottom: 50px;
  }

  .mb-8 {
    margin-bottom: 16px !important;
  }
}
</style> 